import { jsx as _jsx } from "react/jsx-runtime";
import { AccountEmpty } from '../account-empty';
import { useMemo } from 'react';
export default function ComponentWeb({ onPressCta, }) {
    const props = useMemo(() => {
        return {
            callout: {
                title: 'Trading',
                message: 'Trade seamlessly through our trading platform user interface. We support digital assets such as tokens, yield-bearing stablecoins and tokenized real-world assets.',
                ctas: [
                    {
                        variant: 'secondary',
                        label: 'Explore our digital assets',
                        onPress: onPressCta,
                        size: 'base',
                        style: { width: 'auto' },
                    },
                ],
            },
            imageUri: {
                XS: 'product-splash/trading/Base@3x.png',
                S: 'product-splash/trading/LG@2x.png',
                M: 'product-splash/trading/LG@3x.png',
                L: 'product-splash/trading/XL@2x.png',
                XL: 'product-splash/trading/XL@3x.png',
            },
            cards: [
                {
                    icon: 'SwapHorizontalCircle',
                    label: 'Hassle-free on/off ramps',
                    description: 'Our seamless fiat rails facilitate streamlined transactions in USD, GBP, and EUR.',
                },
                {
                    icon: 'DeviceHub',
                    label: 'Layer 1 & 2 tokens, stablecoins, tokenized assets',
                    description: 'We support digital assets such as tokens, yield-bearing stablecoins and tokenized real-world assets.',
                },
                {
                    icon: 'AddIcCall',
                    label: 'White-glove service multi-channel support',
                    description: 'Enjoy personalized support and custom solutions for high-volume trades.',
                },
            ],
        };
    }, [onPressCta]);
    return _jsx(AccountEmpty, Object.assign({}, props));
}
